import { Loader } from './Loader';

/**
 * Fallback for route-level Suspense boundaries and the router's hydrate gap.
 *
 * A thin wrapper over `Loader` so route-level waits are named in one place and
 * look identical to every other wait in the app.
 */
export const PageLoader = () => <Loader size="page" label="Loading this page" />;
